import React from 'react';
import { RoutesType } from '@fle-ui/plus-router';
import Layout from '@/layout';

const router: RoutesType = [
	{
		path: '/',
		element: <Layout />,
		children: [
			// 商城设置
			{
				path: '/weapp/mall',
				component: () => import(/* webpackChunkName: "site-ownStore" */ '@/views/OwnStore/manage')
			},
			// 官网设置
			{
				path: '/weapp/official',
				component: () => import(/* webpackChunkName: "site-ownStore" */ '@/views/OwnStore/official')
			},
			// 分采通名片微页面配置
			{
				path: '/weapp/official-tmalljx',
				component: () => import(/* webpackChunkName: "site-ownStore" */ '@/views/OwnStore/official')
			},
			// 商城风格设置
			{
				path: '/weapp/mall/theme',
				component: () => import(/* webpackChunkName: "site-ownStore" */ '@/views/OwnStore/SaasH5/SettingThemes')
			},
			// 商品
			{
				path: '/weapp/promotion/goods',
				component: () =>
					import(/* webpackChunkName: "site-mineCommodity-commodity" */ '@/views/MineCommodity/Commodity')
			},
			{
				path: '/mineCommodity/group',
				component: () =>
					import(/* webpackChunkName: "site-mineCommodity-newGroup" */ '@/views/MineCommodity/CommodityGroup/list')
			},
			{
				path: '/mineCommodity/group/edit',
				component: () =>
					import(
						/* webpackChunkName: "site-mineCommodity-newGroup-edit" */ '@/views/MineCommodity/CommodityGroup/create'
					)
			}
			// 订单
			// {
			//   path: '/order/orderManage',
			//   component: () => import(/* webpackChunkName: "site-order-orderManage" */ '@/views/OrderManage'),
			// },
			// {
			//   path: '/order/orderManage/detail/:orderId',
			//   component: () => import(/* webpackChunkName: "site-order-orderManage-detail" */ '@/views/OrderManage'),
			// },
			// {
			//   path: '/order/afterSaleManage',
			//   component: () => import(/* webpackChunkName: "site-order-afterSaleManage" */ '@/views/OrderManage'),
			// },
			// {
			//   path: '/order/afterSaleManage/detail/:orderId',
			//   component: () => import(/* webpackChunkName: "site-order-afterSaleManage-detail" */ '@/views/OrderManage'),
			// },
			// 设置
			// {
			//   path: '/site/setting',
			//   component: () => import(/* webpackChunkName: "site-site-setting" */ '@/views/Site/List'),
			// },
			// {
			//   path: '/site/manage',
			//   component: () => import(/* webpackChunkName: "site-site-manage" */ '@/views/Site/List'),
			// },
			// {
			//   path: '/site/interface',
			//   component: () => import(/* webpackChunkName: "site-site-interface" */ '@/views/Site/List'),
			// },
			// {
			//   path: '/site/agreement',
			//   component: () => import(/* webpackChunkName: "site-site-agreement" */ '@/views/Site/List'),
			// },
		]
	}
];

export default router;
